import React, { Component } from 'react';
import CalendarIcon from '@assets/icons/calendar-icon.svg';
import editImageIcon from '@assets/icons/edit-icon.svg';
import Request from 'Object/request/myoperation/resource_allocation';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import Select from 'react-select';
import { connect } from 'react-redux';
import Popup from '../../Popup';
import EditRouteEndPoint from '../../RouteDetails/EditRouteEndPoint';
import {
  resourceAllocationMyOperationRequest,
  resourceIsochronousMyOperationRequest,
} from '@core/api/resourceAllocation/resourceAllocation.service';
import '../MyOperation.css';
import TextDetail from '~/TextDetail/TextDetail.component';
import Grid from '@mui/material/Grid2';

class AssignResourcesPopup extends Component {
  constructor(props) {
    super();
    this.state = {
      daypickers: {
        daypickerone: false,
        daypickertwo: false,
      },
      from: null,
      to: null,
      showEditRouteEndPoint: false,
      endLocation: null,
    };
  }
  componentDidMount() {
    this.getIsochronoes();
  }
  getIsochronoes = () => {
    const body = Request.getAllIsochronous();
    const onSuccess = (response) => this.renderIsochronoes(response);
    const loadingConfig = { dispatch: this.props.dispatch };
    resourceIsochronousMyOperationRequest(body, onSuccess, null, loadingConfig);
  };
  renderIsochronoes = (response) => {
    if (response.isochronous) {
      this.buildIsochronous(response.isochronous);
    }
  };
  buildIsochronous = (isochronous) => {
    const isochronousSelect = isochronous.map((iso) => {
      const agents = iso.agents?.length || 0;
      return {
        label: `${iso.name} - #${this.props.lan.agents}: ${agents}`,
        value: iso,
      };
    });
    this.setState({ isochronous: isochronousSelect, originalIsochronous: isochronous });
  };
  validateData = () => {
    const { isochrone, from, to } = this.state;
    if (isochrone && from && to && from <= to) {
      this.setState({ showErrorMessage: false });
      this.assignResources();
    } else {
      this.setState({ showErrorMessage: true });
    }
  };
  assignResources = () => {
    const { isochrone, from, to, endLocation } = this.state;
    const data = {
      idIsochronous: isochrone.id,
      fromYear: from.getFullYear(),
      fromMonth: from.getMonth(),
      fromDay: from.getDate(),
      toYear: to.getFullYear(),
      toMonth: to.getMonth(),
      toDay: to.getDate(),
      endLocation: endLocation,
    };
    const body = Request.getTasksToResourceAllocation(data);
    const onSuccess = (response) => this.props.onClose({ statusCode: 200, response });
    const onError = () => this.setState({ showErrorMessage: true });
    const loadingConfig = { dispatch: this.props.dispatch };
    resourceAllocationMyOperationRequest(body, onSuccess, onError, loadingConfig);
  };
  handleFromDate = (date) => this.setState({ from: date });
  handleToDate = (date) => this.setState({ to: date });
  showDayPickerInput = (key) => {
    this.setState((prevState) => ({
      daypickers: {
        ...prevState.daypickers,
        [key]: !prevState.daypickers[key],
      },
    }));
  };
  render() {
    const {
      daypickers,
      from,
      to,
      showErrorMessage,
      showEditRouteEndPoint,
      endLocation,
    } = this.state;

    return (
      <Popup
        title={this.props.lan.allocateResources}
        icon="assign-resources-icon.svg"
        show
        closeButton
        onClose={this.props.onClose}
        buttonText={this.props.lan.allocateResources}
        buttonOnClick={this.validateData}
      >
        {/* Period label */}
        <Grid container>
          <Grid className="popup-label">{this.props.lan.periodTime}</Grid>
        </Grid>

        {/* Date range inputs */}
        <Grid container className="Fielder-input-border" alignItems="center">
          <Grid size="auto">
            <img
              src={CalendarIcon}
              className="icon my-2"
              alt=""
              onClick={() => this.showDayPickerInput('daypickerone')}
            />
          </Grid>
          <Grid>
            <input
              className="day-picker-input my-2"
              id="input-date-from"
              value={from ? from.toLocaleDateString() : ''}
              readOnly
              placeholder={this.props.lan.from}
              onClick={() => this.showDayPickerInput('daypickerone')}
            />
            {daypickers.daypickerone && (
              <DayPicker mode="single" selected={from} onSelect={this.handleFromDate} />
            )}
          </Grid>

          <Grid size="auto">
            <img
              src={CalendarIcon}
              className="icon my-2 MyOperation-img-input"
              alt=""
              onClick={() => this.showDayPickerInput('daypickertwo')}
            />
          </Grid>
          <Grid>
            <input
              className="day-picker-input my-2"
              value={to ? to.toLocaleDateString() : ''}
              readOnly
              placeholder={this.props.lan.to}
              onClick={() => this.showDayPickerInput('daypickertwo')}
            />
            {daypickers.daypickertwo && (
              <DayPicker mode="single" selected={to} onSelect={this.handleToDate} />
            )}
          </Grid>
        </Grid>

        {/* Isochronous select */}
        <Grid container sx={{ mt: 4 }}>
          <Grid size={12}>
            <Select
              className="full-width mt-1 mb-3"
              options={this.state.isochronous}
              onChange={(event) => this.setState({ isochrone: event.value })}
              placeholder={this.props.lan.isochronous}
              key="select_agent"
              classNamePrefix="smart-select"
            />
          </Grid>
        </Grid>

        {/* Route end point row */}
        <Grid container alignItems="center" sx={{ mt: 3 }}>
          <Grid sm>
            <TextDetail
              label={this.props.lan.routeEndPointTitle}
              text={endLocation?.address || this.state.routeEndPointDefault}
            />
          </Grid>
          <Grid size="auto" className="my-auto">
            <img
              src={editImageIcon}
              className="icon"
              alt=""
              onClick={() =>
                this.setState({ showEditRouteEndPoint: !showEditRouteEndPoint })
              }
            />
          </Grid>
        </Grid>

        {/* Error message */}
        {showErrorMessage && (
          <Grid container>
            <Grid className="MyOperation-form-hint">
              <p>{this.props.lan.errorEnsureInformationCorrect}</p>
            </Grid>
          </Grid>
        )}

        {/* Edit endpoint modal */}
        {showEditRouteEndPoint && (
          <EditRouteEndPoint
            {...this.props}
            onClose={() => this.setState({ showEditRouteEndPoint: false })}
            onSaveEndPoint={(endPoint) =>
              this.setState({ endLocation: endPoint, showEditRouteEndPoint: false })
            }
          />
        )}
      </Popup>
    );
  }
}
const mapStateToProps = (state) => ({
  user: state.utils.session.user,
});
export default connect(mapStateToProps)(AssignResourcesPopup);
//Original code:
/*import React, { Component } from 'react';
import CalendarIcon from '@assets/icons/calendar-icon.svg';
import editImageIcon from '@assets/icons/edit-icon.svg';
import Request from 'Object/request/myoperation/resource_allocation';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import { connect } from 'react-redux';
import Popup from '../../Popup';
import EditRouteEndPoint from '../../RouteDetails/EditRouteEndPoint';
import { resourceAllocationMyOperationRequest, resourceIsochronousMyOperationRequest } from '@core/api/resourceAllocation/resourceAllocation.service';
import '../MyOperation.css';
import TextDetail from '~/TextDetail/TextDetail.component';

class AssignResourcesPopup extends Component {
  constructor(props) {
    super();
    this.state = {
      daypickers: {
        daypickerone: false,
        daypickertwo: false,
      },
      from: null,
      to: null,
      showEditRouteEndPoint: false,
      endLocation: null,
    };
  }
  componentDidMount() {
    this.getIsochronoes();
  }
  getIsochronoes = () => {
    let body = Request.getAllIsochronous();
    const onSuccess = (response) => this.renderIsochronoes(response);
    const loadingConfig = { dispatch: this.props.dispatch };
    resourceIsochronousMyOperationRequest(body, onSuccess, null, loadingConfig);
  };
  renderIsochronoes = (response) => {
    if (response.isochronous) {
      this.buildIsochronous(response.isochronous);
    }
  };
  buildIsochronous = (isochronous) => {
    const isochronousSelect = isochronous.map((iso) => {
      const agents = iso.agents?.length || 0;
      return {
        label: `${iso.name} - #${this.props.lan.agents}: ${agents}`,
        value: iso,
      };
    });
    this.setState({ isochronous: isochronousSelect, originalIsochronous: isochronous });
  };
  validateData = () => {
    const { isochrone, from, to } = this.state;
    if (isochrone && from && to && from <= to) {
      this.setState({ showErrorMessage: false });
      this.assignResources();
    } else {
      this.setState({ showErrorMessage: true });
    }
  };
  assignResources = () => {
    const { isochrone, from, to, endLocation } = this.state;
    const data = {
      idIsochronous: isochrone.id,
      fromYear: from.getFullYear(),
      fromMonth: from.getMonth(),
      fromDay: from.getDate(),
      toYear: to.getFullYear(),
      toMonth: to.getMonth(),
      toDay: to.getDate(),
      endLocation: endLocation,
    };
    const body = Request.getTasksToResourceAllocation(data);
    const onSuccess = (response) => this.props.onClose({ statusCode: 200, response });
    const onError = () => this.setState({ showErrorMessage: true });
    const loadingConfig = { dispatch: this.props.dispatch };
    resourceAllocationMyOperationRequest(body, onSuccess, onError, loadingConfig);
  };
  handleFromDate = (date) => this.setState({ from: date });
  handleToDate = (date) => this.setState({ to: date });
  showDayPickerInput = (key) => {
    this.setState((prevState) => ({
      daypickers: {
        ...prevState.daypickers,
        [key]: !prevState.daypickers[key],
      },
    }));
  };
  render() {
    const { daypickers, from, to, showErrorMessage, showEditRouteEndPoint, endLocation } = this.state;
    return (
      <Popup
        title={this.props.lan.allocateResources}
        icon='assign-resources-icon.svg'
        show
        closeButton
        onClose={this.props.onClose}
        buttonText={this.props.lan.allocateResources}
        buttonOnClick={this.validateData}
      >
        <Row>
          <Col sm={12}>
            <Row>
              <Col className='popup-label'>{this.props.lan.periodTime}</Col>
            </Row>
            <Row className='Fielder-input-border'>
              <Col sm={'auto'}>
                <img
                  src={CalendarIcon}
                  className='icon my-2'
                  alt=''
                  onClick={() => this.showDayPickerInput('daypickerone')}
                />
              </Col>
              <Col>
                <input
                  className='day-picker-input my-2'
                  id='input-date-from'
                  value={from ? from.toLocaleDateString() : ''}
                  readOnly
                  placeholder={this.props.lan.from}
                  onClick={() => this.showDayPickerInput('daypickerone')}
                />
                {daypickers.daypickerone && (
                  <DayPicker mode='single' selected={from} onSelect={this.handleFromDate} />
                )}
              </Col>
              <Col sm={'auto'}>
                <img
                  src={CalendarIcon}
                  className='icon my-2 MyOperation-img-input'
                  alt=''
                  onClick={() => this.showDayPickerInput('daypickertwo')}
                />
              </Col>
              <Col>
                <input
                  className='day-picker-input my-2'
                  value={to ? to.toLocaleDateString() : ''}
                  readOnly
                  placeholder={this.props.lan.to}
                  onClick={() => this.showDayPickerInput('daypickertwo')}
                />
                {daypickers.daypickertwo && (
                  <DayPicker mode='single' selected={to} onSelect={this.handleToDate} />
                )}
              </Col>
            </Row>
          </Col>
        </Row>

        <Row className='mt-4'>
          <Col>
            <Select
              className='react-select__control full-width mt-1 mb-3'
              options={this.state.isochronous}
              onChange={(event) => this.setState({ isochrone: event.value })}
              placeholder={this.props.lan.isochronous}
              key='select_agent'
            />
          </Col>
        </Row>

        <Row className='mt-3'>
          <Col sm>
            <TextDetail
              label={this.props.lan.routeEndPointTitle}
              text={endLocation?.address || this.state.routeEndPointDefault}
            />
          </Col>
          <Col sm='auto' className='my-auto'>
            <img
              src={editImageIcon}
              className='icon'
              alt=''
              onClick={() => this.setState({ showEditRouteEndPoint: !showEditRouteEndPoint })}
            />
          </Col>
        </Row>

        {showErrorMessage && (
          <Row>
            <Col sm={12} className='MyOperation-form-hint'>
              <p>{this.props.lan.errorEnsureInformationCorrect}</p>
            </Col>
          </Row>
        )}

        {showEditRouteEndPoint && (
          <EditRouteEndPoint
            {...this.props}
            onClose={() => this.setState({ showEditRouteEndPoint: false })}
            onSaveEndPoint={(endPoint) =>
              this.setState({ endLocation: endPoint, showEditRouteEndPoint: false })
            }
          />
        )}
      </Popup>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.utils.session.user,
});

export default connect(mapStateToProps)(AssignResourcesPopup);
*/
